import {getReportTrendLabel} from "./helper";

jQuery(function($){
  let firstLoad = true;

  if ($('.hexagons-wrapper.home-hero').length > 0) {
    const baseUrl = $('#base-url').data('base-url');

    const mbSize = 80; // Hexagon size in for viewport > 639 < 1024;
    const dtSize = 130; // Hexagon size in desktop view;
    const strongPositiveHexagons = $('.hexagon.home-hero.strongpositive');
    const positiveHexagons = $('.hexagon.home-hero.positive');
    const neutralHexagons = $('.hexagon.home-hero.neutral');
    const negativeHexagons = $('.hexagon.home-hero.negative');
    const strongNegativeHexagons = $('.hexagon.home-hero.strongnegative');


    const hexagons = $('.hexagon.home-hero');
    const totalStrongPositiveHex = $('.hexagon.home-hero.strongpositive').length;
    const totalPositiveHex = $('.hexagon.home-hero.positive').length;
    const totalNeutralHex = $('.hexagon.home-hero.neutral').length;
    const totalNegativeHex = $('.hexagon.home-hero.negative').length;
    const totalStrongNegativeHex = $('.hexagon.home-hero.strongnegative').length;
    
    const totalHexs = hexagons.length;
    // const hexRatio = (totalPositiveHex / totalHexs * 100).toFixed(2); // > 50 means positives is more than negatives

    const data = $('#home-hero-json').data('json');

    // console.log('data', data);

    function arrangeHexagons(hexSize, stageWidth) {
      // console.clear();

      const hexPerRowOdd = Math.floor(stageWidth / hexSize); // Number of hexagons per row
      const hexPerRowEven = hexPerRowOdd - 1; // Odd row has one less tile than even row

      // console.log('total: ', totalHexs, ' | strongpositive: ', totalStrongPositiveHex, ' | positive: ', totalPositiveHex, ' | neutral: ', totalNeutralHex, ' | negative: ', totalNegativeHex, ' | strongNegative: ', totalStrongNegativeHex);

      // console.log('hexPerRowOdd: ', hexPerRowOdd, ' | hexPerRowEven:', hexPerRowEven);

      let totalRows = 0; // Total number of rows
      let hexsOnLastRow = 0;
      let temp = totalHexs;

      // Determine number of rows
      while (temp > 0) {
        totalRows++;

        if (totalRows % 2 === 1) {
          temp-=hexPerRowOdd;
        } else {
          temp-=hexPerRowEven;
        }
      }

      // Determine number of hexagons in last row
      if (totalRows % 2 === 1) {
        hexsOnLastRow = hexPerRowOdd + temp;
      } else {
        hexsOnLastRow = hexPerRowEven + temp;
      }

      // console.log('totalRows:', totalRows, ' | hexsOnLastRow:', hexsOnLastRow);

      let hexRef = [];

      let rowCount = 1;
      let colCount = 1;

      let strongPositiveCount = 1;
      let positiveCount = 1;
      let neutralCount = 1;
      let negativeCount = 1;
      let strongNegativeCount = 1;

      let hexCount = 1;

      // console.log('-----------------------------------------------------------', );

      while (hexCount <= totalHexs) {
          // console.log('                 ');
          // console.log(hexCount);
          // console.log('Begin:', 'rowCount:', rowCount, 'colCount:', colCount);

        if (rowCount >= totalRows && colCount > hexsOnLastRow) {
          // console.log('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX');
          // console.log('Invalid:', 'rowCount:', rowCount, 'colCount:', colCount);
          // console.log('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX');

          rowCount = 1;
          colCount++;
        }

        let idx = 0; // idx for hexRef array

        for (let i = 1; i < rowCount; i++) {
          // console.log('row i:', i);
          if (i % 2 === 1) { // Odd row
            // console.log('+ ', hexPerRowOdd);
            idx = idx + hexPerRowOdd;
          } else { // Even row
            // console.log('+ ', hexPerRowEven);
            idx = idx + hexPerRowEven;
          }
        }

        // console.log('+ colCount', colCount - 1);
        idx+=(colCount - 1);

        // console.log('hexCount:', hexCount, 'rowCount:', rowCount, 'colCount:', colCount, ' | idx:', idx);

        // Register hexRef here...
        if (strongPositiveCount <= totalStrongPositiveHex) {
          hexRef[idx] = '++';
          strongPositiveCount++;
        } else if (positiveCount <= totalPositiveHex) {
          hexRef[idx] = '+';
          positiveCount++;
        } else if (neutralCount <= totalNeutralHex) {
          hexRef[idx] = '|';
          neutralCount++;
        } else if (negativeCount <= totalNegativeHex) {
          hexRef[idx] = '-';
          negativeCount++;
        } else if (strongNegativeCount <= totalStrongNegativeHex) {
          hexRef[idx] = '--';
          strongNegativeCount++;
        }

        rowCount++;

        if (rowCount > totalRows) {
          rowCount = 1;
          colCount++;
        }

        if (rowCount % 2 === 0 && colCount >= hexPerRowOdd) {
          rowCount++;
        }

        hexCount++

        // console.log('----------------------------------------------------------- |', );
      }

      // console.log('hexRef', hexRef);

      // return;

      let reshuffledHexagons = [];
      let tempStrongPositiveHexagons = [];
      let tempPositiveHexagons = [];
      let tempNeutralHexagons = [];
      let tempNegativeHexagons = [];
      let tempStrongNegativeHexagons = [];

      strongPositiveHexagons.each(function() {
        tempStrongPositiveHexagons.push($(this));
      });

      positiveHexagons.each(function() {
        tempPositiveHexagons.push($(this));
      });

      neutralHexagons.each(function() {
        tempNeutralHexagons.push($(this));
      });
      
      negativeHexagons.each(function() {
        tempNegativeHexagons.push($(this));
      });
      
      strongNegativeHexagons.each(function() {
        tempStrongNegativeHexagons.push($(this));
      });

      hexRef.map((ref, index) => {
        if (ref === '++') {
          reshuffledHexagons.push(tempStrongPositiveHexagons.shift());
        } else if (ref === '+') {
          reshuffledHexagons.push(tempPositiveHexagons.shift());
        } else if (ref === '-') {
          reshuffledHexagons.push(tempNegativeHexagons.shift());
        } else if (ref === '--') {
          reshuffledHexagons.push(tempStrongNegativeHexagons.shift());
        } else {
          reshuffledHexagons.push(tempNeutralHexagons.shift());
        }
      });

      // console.log('reshuffledHexagons', reshuffledHexagons);

      // Positioning hexagons begin... //////////////////////////////////////////////////////////////////
      let row = 1;
      let col = 1;
      let offsetX = 0;

      reshuffledHexagons.map(function(hex, index) {
        // hex.find('.ref').html(index + 1);

        let endOfCurrentRowIndex = 0;

        // Determine which hexagon index to end current row
        for (let i=1; i<=row; i++) {
          if (i % 2 === 0) { // Even
            endOfCurrentRowIndex+=hexPerRowEven;
          } else {
            endOfCurrentRowIndex+=hexPerRowOdd;
          }
        }

        // End of current row, current hexagon will begin from next row
        if (index >= endOfCurrentRowIndex) {
          row++;
          col = 1;

          // Hexagons on odd row is offset by translateX 50%
          if (row % 2 === 0) {
            offsetX = 50;
          } else {
            offsetX = 0;
          }
        }

        hex.css('width', hexSize + 'px');
        hex.css('top', (hexSize * (row - 1)) + 'px');
        hex.css('left', (hexSize * (col - 1)) + 'px');

        const offsetY = (row - 1) * 15;

        hex.css('transform', 'translate(' + offsetX + '%, -' + offsetY + '%)');

        col++;
      });
      // reshuffledHexagons.map END

      $('.hexagon-country-name').css('font-size', hexSize * 0.125);

      const wrapperHeight = hexSize + ((row - 1) * hexSize * 0.85);

      $('.hexagons-wrapper.home-hero').height(wrapperHeight);

      if (firstLoad) {
        setTimeout(() => {
          $('.hex-loading').fadeOut(function() {
            $('.hex-loading').remove();
            hexagons.removeClass('opacity-0');
          });
        }, 1000);
        firstLoad=!firstLoad;
      }
    }
    // End of arrangeHexagons()

    let timeout;

    $(window).on('resize', function() {
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        // Get window width to determine hexagon's size
        const ww = $(window).width();
        const stageWidth = $('.hexagons-wrapper.home-hero').width();
        let hexSize;

        if (ww < 640) {
          hexSize = Math.floor(stageWidth / 5);
        } else if (ww < 1024) {
          hexSize = mbSize;
        } else {
          hexSize = dtSize;
        }

        arrangeHexagons(hexSize, stageWidth);
      }, 250);
    });

    // Trigger hexagons shuffle on first page load
    $(window).trigger('resize');

    function setOverlayContent(content) {
      const customFlagLists = [
        'af',
        'sy',
      ];

      if (!customFlagLists.includes(content.countryCode.toLowerCase())) {
        $('.cop-hero .hhcp-content.flag').attr('src', 'https://flagcdn.com/w160/' + content.countryCode.toLowerCase() + '.png');
      } else {
        if (window.location.pathname.split('/')[1] == 'democracytracker') { 
          $('.cop-hero .hhcp-content.flag').attr('src', window.location.origin + '/democracytracker/themes/custom/gsod/src/assets/flags/' + content.countryCode.toLowerCase() + '.png');
        } else {
          $('.cop-hero .hhcp-content.flag').attr('src', window.location.origin + '/themes/custom/gsod/src/assets/flags/' + content.countryCode.toLowerCase() + '.png');
        }
      }

      $('.cop-hero .hhcp-content.month').text(content.month + ' ' + content.year);
      $('.cop-hero .hhcp-content.country').text(content.country);

      const trimSummary = content.summary.split(" ").splice(0, 20).join(" ") + '...';

      $('.cop-hero .hhcp-content.summary').text(trimSummary);
      $('.cop-hero .hhcp-content.permalink').attr('href', content.countryProfilePermalink);

      let attributesRef = [];
      attributesRef[0] = { 'code' : 'rg', 'img' : 'representation', 'value' : content.attributes.representation };
      attributesRef[1] = { 'code' : 'fr', 'img' : 'rights', 'value' : content.attributes.rights };
      attributesRef[2] = { 'code' : 'ia', 'img' : 'rule_of_law', 'value' : content.attributes.rule_of_law };
      attributesRef[3] = { 'code' : 'pe', 'img' : 'participation', 'value' : content.attributes.participation };
      // console.log(content)
      $.each(attributesRef, function() {
        const elm = $('.cop-hero .hhcp-content.gsod-attribute.' + this.code);
        elm.parent().hide();

        if (this.value !== 'None' && this.value !== '') {
          elm.attr('src', baseUrl + 'themes/custom/gsod/src/assets/icons/icon-' + this.img + '-' + this.value.toLowerCase() + '.svg');

          const oriTooltip = elm.parent().data('label');
          const newTooltip = oriTooltip + ' (' + getReportTrendLabel(this.value) + ')';

          elm.parent().attr('data-tooltip', newTooltip);
          elm.parent().show();
        }
      });
    }

    $('.hexagon.home-hero').on('click', function(){
      const id = $(this).data('id');
      const content = data[id];
      const panel = $('.country-overlay-panel-hero');
      const loading = $('.country-overlay-panel-hero .loading');

      if (panel.hasClass('active')) {
        loading.fadeIn(300, function() {
          setOverlayContent(content);
          loading.fadeOut(300);
        });
      } else {
        setOverlayContent(content);
        panel.addClass('active');
      }
    });

    $('.button-close-country-panel-hero').on('click', function(){
      $('.country-overlay-panel-hero').removeClass('active');
    });
  }
});
